<script>
export let article;

</script>


<style>

.article-body {

}

:global(.article-body p) {
	margin-bottom: 2.5rem;
	font-size: 1.15rem;
	line-height: 1.85rem;
	color: #3c3c3c;
}

:global(.article-body .image) {
	margin-bottom: 3rem;
	border: 1px solid #000;
}

:global(.article-body .image img) {

}

</style>


<div class="article-body">

	{@html article.article_body}

</div>
